import React from 'react';
import {Button} from '@mui/material';
import {MyAppointmentsEnum} from 'presentation/constants';
import {BookingErrorState} from 'presentation/modules/booking/shared/ui/components/BookingErrorState';
import {BookingLoadingState} from 'presentation/modules/booking/shared/ui/components/BookingLoadingState';
import {translations} from 'presentation/translations-new';
import {Navigate} from 'react-router-dom';
import {useOdontoConfirmationBooking} from './hooks/useOdontoConfirmationBooking';
import {OdontoConfirmationBookingContent} from './components/OdontoConfirmationBookingContent';
import {OdontoConfirmationBookingContentNew} from './components/OdontoConfirmationBookingContentNew';

const {loadError, loading} = translations['pt-br'].commons;

const {confirmationBooking, seeMyAppointments} = translations['pt-br'].privateFlow.bookingFlow;

export function OdontoConfirmationBooking() {
	const {
		goToMyAppointments,
		confirmedBookAppointment,
		appointmentsListLoading,
		appointmentsListError,
		refresh,
		showNewConfirmationPage,
	} = useOdontoConfirmationBooking();

	if (appointmentsListLoading) {
		return (
			<BookingLoadingState
				pageTitle={confirmationBooking}
				loadingText={loading}
				hideBackBtn
			/>
		);
	}

	if (!confirmedBookAppointment) {
		return <Navigate to={MyAppointmentsEnum.MY_APPOINTMENTS} />;
	}

	if (appointmentsListError) {
		return (
			<BookingErrorState
				pageTitle={confirmationBooking}
				errorTitle={loadError}
				handleBack={goToMyAppointments}
				handleRefresh={refresh}>
				<Button
					size="large"
					sx={{mx: 'auto', mt: 2, width: 'min-content'}}
					onClick={goToMyAppointments}>
					{seeMyAppointments}
				</Button>
			</BookingErrorState>
		);
	}

	return showNewConfirmationPage ? (
		<OdontoConfirmationBookingContentNew
			bookedAppointment={confirmedBookAppointment}
			goToMyAppointments={goToMyAppointments}
		/>
	) : (
		<OdontoConfirmationBookingContent
			bookedAppointment={confirmedBookAppointment}
			goToMyAppointments={goToMyAppointments}
		/>
	);
}
